// FRAME_URL is declared externally.
// We use the `declare` keyword to inform TypeScript of its existence and type.
// Therefore, we disable the naming convention rule for this line to avoid linting errors,

declare const FRAME_URL: string | undefined;

const gatewayUrl = "https://webservices.securetrading.net/jwt/";
const mockGatewayUrl = "https://merchant.example.com:8443";

export const ENVIRONMENT = {
  CARDINAL_COMMERCE: {
    CONFIG: {
      logging: { level: "off" },
      timeout: 6000,
      extendedTimeout: 4000,
      maxRequestRetries: 2,
    },
    MOCK: {
      AUTHENTICATE_CARD_URL: `${mockGatewayUrl}/cardinalAuthenticateCard`,
    },
    V2_SONGBIRD_LIVE_URL:
      "https://static.client.cardinaltrusted.com/songbird/v2.1.0/songbird.js",
    V2_SONGBIRD_LIVE_URL_SRI:
      "sha384-ChU6jn6KFsEv8NcjP1ifj3s6LclP7AFS6fTHY2pcBL5yax0FT5viH/cNbOJDnY5E",
    V2_SONGBIRD_TEST_URL:
      "https://cas.static.client.cardinaltrusted.com/songbird/v2.1.0/songbird.js",
    V2_SONGBIRD_TEST_URL_SRI:
      "sha384-SyB1z+tPBr7Pv5x7KYYEqP50NDAIID56G6/WjGzhEkqTEqZsQn9ywSmZyPcU5ym2",
    V1_SONGBIRD_LIVE_URL:
      "https://songbird.cardinalcommerce.com/edge/v1/songbird.js",
    V1_SONGBIRD_TEST_URL:
      "https://songbirdstag.cardinalcommerce.com/edge/v1/songbird.js",
    SONGBIRD_DOMAINS: [
      "static.client.cardinaltrusted.com",
      "cas.static.client.cardinaltrusted.com",
    ],
  },
  FRAME_URL: FRAME_URL || "https://webservices.securetrading.net/js/v3",
  GATEWAY_URL: gatewayUrl,
  NOTIFICATION_TTL: 7000,
  GOOGLE_PAY: {
    GOOGLE_PAY_URL: "https://pay.google.com/gp/p/js/pay.js",
  },
  production: true,
  testEnvironment: false,
  overrideDomain: "",
  THREEDS_TERM_URL:
    "https://payments.securetrading.net/process/payments/threedsmpilistener",
  BROWSER_DATA_URLS: [
    "https://brw.3ds.trustpayments.com/3dss/brw/browserData",
    "https://brw.3ds.trustpayments.com/3dss/brw/aragorn",
    "https://brw.3ds.trustpayments.com/3dss/brw/boromir",
  ],
  REQUEST_TIMEOUT: 30000,
  SENTRY: {
    DSN: "https://861f30aa53308ed9456e702a0ab2f3a2@o4507804384755712.ingest.de.sentry.io/4507804389867600",
    ALLOWED_URLS: [],
    SAMPLE_RATE: 0.7,
  },
  SCRIPT_LOAD_TIMEOUT: 30000,
  PAYPAL: {
    DATA_PARTNER_ATTRIBUTION_ID: "TRUSTPAYMENTS_PSP",
    INTEGRATION_DATE: {
      SANDBOX: "2023-03-31",
      LIVE: "2023-03-31",
    },
    USE_GATEWAY_MOCK: false,
    USE_UI_MOCK: false,
    CLIENT_ID: {
      SANDBOX:
        "ASRoi1WzEK1JTvupdnvypddGrC63m4GCmy9AgXY4Z4wd8vVQ2NLS4e4cplEUyK6fZrSwihkPqtnJq4ci",
      LIVE: "AVq0873SWCW65G8UTVJn97fMe88ouErTYYZQ9BM24jKPewduS5qINOqzW-Vdk-hqwzNfYRUOBt6ygoYr",
    },
  },
  APPLEPAY: {
    APPLE_PAY_SDK_URL:
      "https://applepay.cdn-apple.com/jsapi/1.latest/apple-pay-sdk.js",
    USE_UI_MOCK: false,
    USE_GATEWAY_MOCK: false,
  },
};
